/**
 * @file 一些返回常量数据的 utils
 */
const ZH_COUNTRIES = [
    {
        name: 'A',
        countries: [
            { name: '埃及', code: 'EG' },
            { name: '埃塞俄比亚', code: 'ET' },
            { name: '奥兰群岛', code: 'AX' },
            { name: '奥地利', code: 'AT' },
            { name: '安哥拉', code: 'AO' },
            { name: '安圭拉', code: 'AI' },
            { name: '安提瓜和巴布达', code: 'AG' },
            { name: '安道尔共和国', code: 'AD' },
            { name: '澳大利亚', code: 'AU' },
            { name: '爱尔兰', code: 'IE' },
            { name: '爱沙尼亚', code: 'EE' },
            { name: '阿塞拜疆', code: 'AZ' },
            { name: '阿富汗', code: 'AF' },
            { name: '阿尔及利亚', code: 'DZ' },
            { name: '阿尔巴尼亚', code: 'AL' },
            { name: '阿拉伯利比亚民众国', code: 'LY' },
            { name: '阿拉伯叙利亚共和国', code: 'SY' },
            { name: '阿拉伯联合酋长国', code: 'AE' },
            { name: '阿曼', code: 'OM' },
            { name: '阿根廷', code: 'AR' },
            { name: '阿鲁巴', code: 'AW' },
        ],
    },
    {
        name: 'B',
        countries: [
            { name: '不丹', code: 'BT' },
            { name: '伯利兹', code: 'BZ' },
            { name: '保加利亚', code: 'BG' },
            { name: '冰岛', code: 'IS' },
            { name: '北马里亚纳群岛', code: 'MP' },
            { name: '博茨瓦纳', code: 'BW' },
            { name: '巴勒斯坦领土被占领', code: 'PS' },
            { name: '巴哈马', code: 'BS' },
            { name: '巴基斯坦', code: 'PK' },
            { name: '巴巴多斯', code: 'BB' },
            { name: '巴布亚新几内亚', code: 'PG' },
            { name: '巴拉圭', code: 'PY' },
            { name: '巴拿马', code: 'PA' },
            { name: '巴林', code: 'BH' },
            { name: '巴西', code: 'BR' },
            { name: '布基纳法索', code: 'BF' },
            { name: '布维岛', code: 'BV' },
            { name: '布隆迪', code: 'BI' },
            { name: '比利时', code: 'BE' },
            { name: '波兰', code: 'PL' },
            { name: '波多黎各', code: 'PR' },
            { name: '波斯尼亚和黑塞哥维那', code: 'BA' },
            { name: '玻利维亚', code: 'BO' },
            { name: '白俄罗斯', code: 'BY' },
            { name: '百慕大', code: 'BM' },
            { name: '贝宁', code: 'BJ' },
        ],
    },
    {
        name: 'C',
        countries: [{ name: '赤道几内亚', code: 'GQ' }],
    },
    {
        name: 'D',
        countries: [
            { name: '东帝汶', code: 'TL' },
            { name: '丹麦', code: 'DK' },
            { name: '多哥', code: 'TG' },
            { name: '多米尼加', code: 'DM' },
            { name: '多米尼加共和国', code: 'DO' },
            { name: '德国', code: 'DE' },
        ],
    },
    {
        name: 'E',
        countries: [
            { name: '俄罗斯联邦', code: 'RU' },
            { name: '厄瓜多尔', code: 'EC' },
            { name: '厄立特里亚', code: 'ER' },
        ],
    },
    {
        name: 'F',
        countries: [
            { name: '佛得角', code: 'CV' },
            { name: '斐济', code: 'FJ' },
            { name: '法国', code: 'FR' },
            { name: '法属南部领土', code: 'TF' },
            { name: '法属圭亚那', code: 'GF' },
            { name: '法属波利尼西亚', code: 'PF' },
            { name: '法罗群岛', code: 'FO' },
            { name: '福克兰群岛（马尔维纳斯）', code: 'FK' },
            { name: '芬兰', code: 'FI' },
            { name: '菲律宾', code: 'PH' },
        ],
    },
    {
        name: 'G',
        countries: [
            { name: '关岛', code: 'GU' },
            { name: '冈比亚', code: 'GM' },
            { name: '刚果', code: 'CG' },
            { name: '刚果民主共和国', code: 'CD' },
            { name: '古巴', code: 'CU' },
            { name: '哥伦比亚', code: 'CO' },
            { name: '哥斯达黎加', code: 'CR' },
            { name: '圭亚那', code: 'GY' },
            { name: '根西岛', code: 'GG' },
            { name: '格林纳达', code: 'GD' },
            { name: '格陵兰岛', code: 'GL' },
            { name: '格鲁吉亚', code: 'GE' },
            { name: '瓜德罗普岛', code: 'GP' },
        ],
    },
    {
        name: 'H',
        countries: [
            { name: '哈萨克斯坦', code: 'KZ' },
            { name: '洪都拉斯', code: 'HN' },
            { name: '海地', code: 'HT' },
            { name: '荷兰', code: 'NL' },
            { name: '荷属安的列斯群岛', code: 'AN' },
            { name: '赫德岛和麦克唐纳群岛', code: 'HM' },
            { name: '韩国共和国', code: 'KR' },
        ],
    },
    {
        name: 'J',
        countries: [
            { name: '几内亚', code: 'GN' },
            { name: '几内亚比绍', code: 'GW' },
            { name: '加拿大', code: 'CA' },
            { name: '加纳', code: 'GH' },
            { name: '加蓬', code: 'GA' },
            { name: '吉尔吉斯斯坦', code: 'KG' },
            { name: '吉布提', code: 'DJ' },
            { name: '基里巴斯', code: 'KI' },
            { name: '捷克共和国', code: 'CZ' },
            { name: '柬埔寨', code: 'KH' },
            { name: '津巴布韦', code: 'ZW' },
        ],
    },
    {
        name: 'K',
        countries: [
            { name: '克罗地亚', code: 'HR' },
            { name: '卡塔尔', code: 'QA' },
            { name: '喀麦隆', code: 'CM' },
            { name: '库克群岛', code: 'CK' },
            { name: '开曼群岛', code: 'KY' },
            { name: '科威特', code: 'KW' },
            { name: '科摩罗', code: 'KM' },
            { name: '科特迪瓦', code: 'CI' },
            { name: '科科斯（基林）群岛', code: 'CC' },
            { name: '肯尼亚', code: 'KE' },
        ],
    },
    {
        name: 'L',
        countries: [
            { name: '列支敦士登', code: 'LI' },
            { name: '利比里亚', code: 'LR' },
            { name: '卢旺达', code: 'RW' },
            { name: '卢森堡', code: 'LU' },
            { name: '拉脱维亚', code: 'LV' },
            { name: '留尼旺', code: 'RE' },
            { name: '立陶宛', code: 'LT' },
            { name: '罗马尼亚', code: 'RO' },
            { name: '罗马教廷（梵蒂冈城国）', code: 'VA' },
            { name: '老挝人民民主共和国', code: 'LA' },
            { name: '莱索托', code: 'LS' },
            { name: '黎巴嫩', code: 'LB' },
        ],
    },
    {
        name: 'M',
        countries: [
            { name: '墨西哥', code: 'MX' },
            { name: '孟加拉国', code: 'BD' },
            { name: '密克罗尼西亚联邦国', code: 'FM' },
            { name: '摩尔多瓦共和国', code: 'MD' },
            { name: '摩洛哥', code: 'MA' },
            { name: '摩纳哥', code: 'MC' },
            { name: '毛里塔尼亚', code: 'MR' },
            { name: '毛里求斯', code: 'MU' },
            { name: '秘鲁', code: 'PE' },
            { name: '缅甸', code: 'MM' },
            { name: '美国', code: 'US' },
            { name: '美国本土外小岛屿', code: 'UM' },
            { name: '美属维尔京群岛', code: 'VI' },
            { name: '美属萨摩亚', code: 'AS' },
            { name: '莫桑比克', code: 'MZ' },
            { name: '蒙古', code: 'MN' },
            { name: '蒙特塞拉特', code: 'MS' },
            { name: '马尔代夫', code: 'MV' },
            { name: '马恩岛', code: 'IM' },
            { name: '马拉维', code: 'MW' },
            { name: '马提尼克岛', code: 'MQ' },
            { name: '马来西亚', code: 'MY' },
            { name: '马约特岛', code: 'YT' },
            { name: '马绍尔群岛', code: 'MH' },
            { name: '马耳他', code: 'MT' },
            { name: '马达加斯加', code: 'MG' },
            { name: '马里', code: 'ML' },
        ],
    },
    {
        name: 'N',
        countries: [
            { name: '南乔治亚岛和南桑威奇群岛', code: 'GS' },
            { name: '南极洲', code: 'AQ' },
            { name: '南非', code: 'ZA' },
            { name: '尼加拉瓜', code: 'NI' },
            { name: '尼日利亚', code: 'NG' },
            { name: '尼日尔', code: 'NE' },
            { name: '尼泊尔', code: 'NP' },
            { name: '挪威', code: 'NO' },
            { name: '瑙鲁', code: 'NR' },
            { name: '纳米比亚', code: 'NA' },
            { name: '纽埃', code: 'NU' },
            { name: '诺福克岛', code: 'NF' },
        ],
    },
    {
        name: 'P',
        countries: [
            { name: '帕劳', code: 'PW' },
            { name: '皮特凯恩', code: 'PN' },
            { name: '葡萄牙', code: 'PT' },
        ],
    },
    {
        name: 'Q',
        countries: [{ name: '前南斯拉夫的马其顿共和国', code: 'MK' }],
    },
    {
        name: 'R',
        countries: [
            { name: '日本', code: 'JP' },
            { name: '瑞典', code: 'SE' },
            { name: '瑞士', code: 'CH' },
        ],
    },
    {
        name: 'S',
        countries: [
            { name: '圣卢西亚', code: 'LC' },
            { name: '圣基茨和尼维斯', code: 'KN' },
            { name: '圣多美和普林西比', code: 'ST' },
            { name: '圣文森特和格林纳丁斯', code: 'VC' },
            { name: '圣皮埃尔和密克隆', code: 'PM' },
            { name: '圣诞岛', code: 'CX' },
            { name: '圣赫勒拿', code: 'SH' },
            { name: '圣马力诺', code: 'SM' },
            { name: '塞内加尔', code: 'SN' },
            { name: '塞尔维亚和黑山', code: 'CS' },
            { name: '塞拉利昂', code: 'SL' },
            { name: '塞浦路斯', code: 'CY' },
            { name: '塞舌尔', code: 'SC' },
            { name: '所罗门群岛', code: 'SB' },
            { name: '斯威士兰', code: 'SZ' },
            { name: '斯洛伐克', code: 'SK' },
            { name: '斯洛文尼亚', code: 'SI' },
            { name: '斯瓦尔巴群岛和扬马延岛', code: 'SJ' },
            { name: '斯里兰卡', code: 'LK' },
            { name: '沙特阿拉伯', code: 'SA' },
            { name: '索马里', code: 'SO' },
            { name: '苏丹', code: 'SD' },
            { name: '苏里南', code: 'SR' },
            { name: '萨尔瓦多', code: 'SV' },
            { name: '萨摩亚', code: 'WS' },
        ],
    },
    {
        name: 'T',
        countries: [
            { name: '图瓦卢', code: 'TV' },
            { name: '土库曼斯坦', code: 'TM' },
            { name: '土耳其', code: 'TR' },
            { name: '坦桑尼亚联合共和国', code: 'TZ' },
            { name: '塔吉克斯坦', code: 'TJ' },
            { name: '托克劳', code: 'TK' },
            { name: '汤加', code: 'TO' },
            { name: '泰国', code: 'TH' },
            { name: '特克斯和凯科斯群岛', code: 'TC' },
            { name: '特立尼达和多巴哥', code: 'TT' },
            { name: '突尼斯', code: 'TN' },
        ],
    },
    {
        name: 'W',
        countries: [
            { name: '乌克兰', code: 'UA' },
            { name: '乌兹别克斯坦', code: 'UZ' },
            { name: '乌干达', code: 'UG' },
            { name: '乌拉圭', code: 'UY' },
            { name: '危地马拉', code: 'GT' },
            { name: '委内瑞拉', code: 'VE' },
            { name: '文莱达鲁萨兰国', code: 'BN' },
            { name: '瓦利斯和富图纳', code: 'WF' },
            { name: '瓦努阿图', code: 'VU' },
        ],
    },
    {
        name: 'X',
        countries: [
            { name: '匈牙利', code: 'HU' },
            { name: '希腊', code: 'GR' },
            { name: '新加坡', code: 'SG' },
            { name: '新喀里多尼亚', code: 'NC' },
            { name: '新西兰', code: 'NZ' },
            { name: '西撒哈拉', code: 'EH' },
            { name: '西班牙', code: 'ES' },
        ],
    },
    {
        name: 'Y',
        countries: [
            { name: '也门', code: 'YE' },
            { name: '亚美尼亚', code: 'AM' },
            { name: '以色列', code: 'IL' },
            { name: '伊拉克', code: 'IQ' },
            { name: '伊朗伊斯兰共和国', code: 'IR' },
            { name: '印度', code: 'IN' },
            { name: '印度尼西亚', code: 'ID' },
            { name: '意大利', code: 'IT' },
            { name: '牙买加', code: 'JM' },
            { name: '约旦', code: 'JO' },
            { name: '英国', code: 'GB' },
            { name: '英属印度洋领地', code: 'IO' },
            { name: '英属维尔京群岛', code: 'VG' },
            { name: '越南', code: 'VN' },
        ],
    },
    {
        name: 'Z',
        countries: [
            { name: '中国', code: 'CN' },
            { name: '中国澳门', code: 'MO' },
            { name: '中国台湾省', code: 'TW' },
            { name: '中国香港', code: 'HK' },
            { name: '中非共和国', code: 'CF' },
            { name: '乍得', code: 'TD' },
            { name: '智利', code: 'CL' },
            { name: '朝鲜民主人民共和国', code: 'KP' },
            { name: '泽西岛', code: 'JE' },
            { name: '直布罗陀', code: 'GI' },
            { name: '赞比亚', code: 'ZM' },
        ],
    },
];
/**
 * 获取国家列表
 * TODO 后续应当支持传一个 locale 参数，返回不同的中英列表
 *
 * @returns 国家列表
 */
export const getCountries = () => ZH_COUNTRIES;
const NATIONALITIES = [
    {
        code: '01',
        name: '汉族',
    },
    {
        code: '02',
        name: '蒙古族',
    },
    {
        code: '03',
        name: '回族',
    },
    {
        code: '04',
        name: '藏族',
    },
    {
        code: '05',
        name: '维吾尔族',
    },
    {
        code: '06',
        name: '苗族',
    },
    {
        code: '07',
        name: '彝族',
    },
    {
        code: '08',
        name: '壮族',
    },
    {
        code: '09',
        name: '布依族',
    },
    {
        code: '10',
        name: '朝鲜族',
    },
    {
        code: '11',
        name: '满族',
    },
    {
        code: '12',
        name: '侗族',
    },
    {
        code: '13',
        name: '瑶族',
    },
    {
        code: '14',
        name: '白族',
    },
    {
        code: '15',
        name: '土家族',
    },
    {
        code: '16',
        name: '哈尼族',
    },
    {
        code: '17',
        name: '哈萨克族',
    },
    {
        code: '18',
        name: '傣族',
    },
    {
        code: '19',
        name: '黎族',
    },
    {
        code: '20',
        name: '傈僳族',
    },
    {
        code: '21',
        name: '佤族',
    },
    {
        code: '22',
        name: '畲族',
    },
    {
        code: '23',
        name: '高山族',
    },
    {
        code: '24',
        name: '拉祜族',
    },
    {
        code: '25',
        name: '水族',
    },
    {
        code: '26',
        name: '东乡族',
    },
    {
        code: '27',
        name: '纳西族',
    },
    {
        code: '28',
        name: '景颇族',
    },
    {
        code: '29',
        name: '柯尔克孜族',
    },
    {
        code: '30',
        name: '土族',
    },
    {
        code: '31',
        name: '达斡尔族',
    },
    {
        code: '32',
        name: '仫佬族',
    },
    {
        code: '33',
        name: '羌族',
    },
    {
        code: '34',
        name: '布朗族',
    },
    {
        code: '35',
        name: '撒拉族',
    },
    {
        code: '36',
        name: '毛难族',
    },
    {
        code: '37',
        name: '仡佬族',
    },
    {
        code: '38',
        name: '锡伯族',
    },
    {
        code: '39',
        name: '阿昌族',
    },
    {
        code: '40',
        name: '普米族',
    },
    {
        code: '41',
        name: '塔吉克族',
    },
    {
        code: '42',
        name: '怒族',
    },
    {
        code: '43',
        name: '乌孜别克族',
    },
    {
        code: '44',
        name: '俄罗斯族',
    },
    {
        code: '45',
        name: '鄂温克族',
    },
    {
        code: '46',
        name: '崩龙族',
    },
    {
        code: '47',
        name: '保安族',
    },
    {
        code: '48',
        name: '裕固族',
    },
    {
        code: '49',
        name: '京族',
    },
    {
        code: '50',
        name: '塔塔尔族',
    },
    {
        code: '51',
        name: '独龙族',
    },
    {
        code: '52',
        name: '鄂伦春族',
    },
    {
        code: '53',
        name: '赫哲族',
    },
    {
        code: '54',
        name: '门巴族',
    },
    {
        code: '55',
        name: '珞巴族',
    },
    {
        code: '56',
        name: '基诺族',
    },
    {
        code: '57',
        name: '其他',
    },
    {
        code: '58',
        name: '外国血统中国籍人士',
    },
];
/**
 * 获取民族列表
 *
 * @returns 民族列表
 */
export const getNationalities = () => NATIONALITIES;
//# sourceMappingURL=data:application/json;base64,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